import { useQuery } from "@tanstack/react-query";
import Axios from "@/lib/axios-instance";

// API call to get a specific plan feature
export const getStoreDetails = async (storeId: string) => {
    const response = await Axios.get(`/store/${storeId}`);
    return response.data;
};

// React Query hook
export const useGetStoreDetails = (storeId: string) => {
    return useQuery({
        queryKey: ["get-store-details", storeId],
        queryFn: () => getStoreDetails(storeId),
        enabled: !!storeId, // Only run if ID is provided
        retry: 1,
    });
};
